export default __webpack_public_path__ + "static/media/photo5.9e71ecd5.jpg";